import React from "react";
import useContextMenu from "../../../../hooks/useContextMenu";
import styles from "../Preview/preview.module.css";

const ContextMenu = ({ options, reference }) => {
  const { anchorPoint, show } = useContextMenu();

  if (show) {
    return (
      <ul
        className={styles.menu}
        style={{
          top: anchorPoint.y - (reference ? reference.current.offsetTop : 0),
          left: anchorPoint.x - (reference ? reference.current.offsetLeft : 0),
        }}
      >
        {options.map((option, index) => (
          <li key={index} onClick={option.handler} className={styles.menu_item}>
            {option.value}
          </li>
        ))}
      </ul>
    );
  }
  return <></>;
};

export default ContextMenu;
